// Lightweight GA4 (gtag.js) event helper. gtag is loaded in index.html.
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
  } else if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(["event", name, params]);
  }
}

/** Fires once per page load, guarded by a key. */
const fired = new Set<string>();
export function trackOnce(key: string, name: string, params: Record<string, unknown> = {}) {
  if (fired.has(key)) return;
  fired.add(key);
  trackEvent(name, params);
}
